import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";


const WebDevelopmentServices = () => {



  useEffect(() => {
    AOS.init({
      duration: 1000
    });
  }, []);
  

  return (
     <section className="bg-bgDefault text-white px-5 py-24 lg:px-16 lg:py-28">
    <div className="container xl:mx-auto xl:max-w-screen-xl">
    <div className='grid grid-cols-1 lg:grid-cols-12 gap-10 items-center' data-aos="fade-up">
    
    {/* Left Text Section */}
    <div className="lg:col-span-8 ">
      <h2 className="text-heading-4 tracking-[-0.06em] md:text-heading-1 font-dmsans font-bold  mb-4">
        Our Services
      </h2>
      <p className=" text-body text-[#9E9E9E] lg:mb-10 xl:pr-32 lg:text-regular ">
        At Techxplore, we design and build technology that empowers businesses to grow, scale, and lead with confidence.
      </p>
      <p className=" text-body text-[#9E9E9E] lg:mb-10 xl:pr-32 lg:text-regular ">
        Our services are crafted with our C.A.R.E. framework - Collaborative Approach, Accountable Ownership, Result-Driven Delivery, and Enduring Trust - ensuring that every partnership is built on transparency and long-term success.
      </p>
    </div>

    {/* Right Icon Section */}
    <div className="lg:col-span-4 flex justify-start md:justify-end ">
      <img
        src="/services_img/web_development.png"
        alt="Web Development Icon"
        className="w-full max-w-[400px] object-contain  "
      />
    </div>
  </div>
  </div>
</section>
    );
  };

export default WebDevelopmentServices;
